import {FileRequirementFormComponent} from './FileRequirementFormComponent';


FileRequirementFormComponent.displayName = 'FileRequirementForm';

export const FileRequirementForm = FileRequirementFormComponent;



// WEBPACK FOOTER //
// ./src/js/requirements/components/FileRequirementForm/index.js